jQuery(document).ready(function () {
    if ($('.dnTicketdesigner').length) {

        var oParentWidth;
        var parentMaxWidth;
        var parentMinWidth;
        var parentMinHeight;
        var parentMaxHeight;
        var minFieldSize;
        var maxFieldSize;
        var minFontSize;
        var maxFontSize;
        var aspectRatio;
        var fieldSizeFactor;
        var fontSizeFactor;

        function getVariables(object) {
            oParentWidth = object.parent('.dnTicketdesigner-container').outerWidth();

            parentMaxWidth = oParentWidth * 0.6; //Maximale Breite der Elemente
            parentMinWidth = oParentWidth * 0.2; //Minimalde Breite der Elemente
            parentMinHeight = oParentWidth * 0.017; //Minimale Höhe des Elements
            parentMaxHeight = oParentWidth * 0.137; //Maximale Höhe des Elements
            minFieldSize = 0.3;   //Minimaler Wert für das Größenfeld
            maxFieldSize = 4;     //Maximaler Wert für das Größenfeld
            minFontSize = oParentWidth * 0.015;           //Minimaler px (font-size) Wert bei voller Größer (parentMaxWidth)
            maxFontSize = oParentWidth * 0.185;           //Maximaler px (font-size) Wert bei voller Größer (parentMaxWidth)
            aspectRatio = false; //Aspec ratio aus

            if (object.hasClass('dnTicketdesigner-object-qrcode')) {
                parentMaxWidth = oParentWidth * 0.26;
                parentMaxHeight = oParentWidth * 0.26;
                parentMinWidth = oParentWidth * 0.1;
                parentMinHeight = oParentWidth * 0.1;
                minFieldSize = 2;
                maxFieldSize = 5.5;
                aspectRatio = true;
            }

            fieldSizeFactor = (maxFieldSize - minFieldSize) / (parentMaxHeight - parentMinHeight); //Faktor zum Umrechnen von Größenwert auf Feldhöhe (parentMaxWidth)
            fontSizeFactor = (maxFontSize - minFontSize) / (parentMaxHeight - parentMinHeight); //Faktor zum Umrechnen von Größenwert auf FontSize
        }

        function initialize(object) {
            var oParentWidth = object.parent('.dnTicketdesigner-container').outerWidth();
            var oParentHeight = object.parent('.dnTicketdesigner-container').outerHeight();

            var posX = object.attr('data-position-x');
            var posY = object.attr('data-position-y');
            var posSize = object.attr('data-position-size');
            var posXVal = $(posX).val();
            var posYVal = $(posY).val();

            var posSizeVal = $(posSize).val();
            if (posSizeVal < minFieldSize) {
                $(posSize).val(minFieldSize);
                posSizeVal = $(posSize).val();
            }

            var pxWidth = (posSizeVal - minFieldSize) / fieldSizeFactor + parentMinWidth;
            var pxHeight = (posSizeVal - minFieldSize) / fieldSizeFactor + parentMinHeight;
            var fontSize = (pxHeight - parentMinHeight) * fontSizeFactor + minFontSize;

            var isQr = false;
            if (object.hasClass('dnTicketdesigner-object-qrcode')) {
                isQr = true;
            }

            object.css('left', cmToPixel(posXVal, oParentWidth));
            object.css('top', cmToPixel(posYVal, oParentHeight, pxHeight, isQr));
            object.css('font-size', fontSize + 'px');
            object.css('width', pxWidth + 'px');
            if (isQr) {
                object.css('height', pxWidth + 'px');
            } else {
                object.css('height', pxHeight + 'px');
            }

            if (object.attr('data-move') == 'true') {
                object.appendTo('.dnTicketdesigner-container-list');
                object.removeAttr('data-move');
            }
        }

        function ticketdesignerInitialize() {
            $('.dnTicketdesigner-object').each(function () {
                var object = $(this);

                getVariables(object);

                object.clayfy({
                    type: 'resizable',
                    droppable: '.dnTicketdesigner-container',
                    migrate: true,
                    preserveAspectRatio: aspectRatio,
                    minSize: [parentMinWidth, parentMinHeight],
                    maxSize: [parentMaxWidth, parentMaxHeight],
                    escape: false,
                    delay: 0,
                    not: '.dnTicketdesigner-object-edit, .dnTicketdesigner-object-edit-icon',
                    top: false,
                    left: false,
                });
                object.on({
                    'clayfy-drop': function (e) {
                        dragToFields(object);
                    },
                    'clayfy-resize': function (e) {
                        dragToFields(object);
                    },
                    'clayfy-dragenter': function (e) { //Checkbox zum anzeigen wird je nach Feld angehakt
                        var oParent = $(e.target);
                        var posShow = object.attr('data-position-show');
                        if (oParent.attr('data-show') == 'show') {
                            $(posShow).prop("checked", true);
                        } else {
                            $(posShow).prop("checked", false);
                        }
                    },
                    'clayfy-dragstart': function (e) {
                        if (object.parent('.dnTicketdesigner-container').hasClass('dnTicketdesigner-container-list')) {
                            object.css('top', 'auto');
                            object.css('left', 'auto');
                        }
                        object.addClass('dnTicketdesigner-object-isDragged');
                    },

                });

                initialize(object);
            });
        }

        function cmToPixel(cm, pxparent, height, isQr) {
            var mmA4 = 0;
            if (height) {
                mmA4 = 297;
            } else {
                mmA4 = 210;
            }
            var mm = cm * 10;
            var factor = mm / mmA4;
            var px = pxparent * factor;
            if (height && !isQr) {
                px -= height;
            }
            return px;
        }

        function pixelToCm(px, pxparent, height, isQr) {
            var mmA4 = 0;
            if (height) {
                mmA4 = 297;
                if (!isQr) {
                    px += height;
                }
            } else {
                mmA4 = 210;
            }
            var factor = px / pxparent;
            var mm = mmA4 * factor;
            var cm = mm / 10;
            return cm;
        }

        function dragToFields(e) {
            getVariables(e);

            var oParent = e.parent('.dnTicketdesigner-container');

            var oPosX = e.position().left;
            if (oPosX < 1) {
                oPosX = 1;
            }
            var oPosY = e.position().top;
            if (oPosY < 1) {
                oPosY = 1;
            }
            var isQr = false;
            if (e.hasClass('dnTicketdesigner-object-qrcode')) {
                isQr = true;
            }
            var posX = e.attr('data-position-x');
            var posY = e.attr('data-position-y');
            var posSize = e.attr('data-position-size');

            var fontSize = (e.outerHeight() - parentMinHeight) * fontSizeFactor + minFontSize;
            var size = (e[0].getBoundingClientRect().height - parentMinHeight) * fieldSizeFactor + minFieldSize;

            $(posX).val(Math.round(pixelToCm(oPosX, oParent.outerWidth()) * 100) / 100);
            $(posY).val(Math.round(pixelToCm(oPosY, oParent.outerHeight(), e.outerHeight(), isQr) * 100) / 100);
            $(posSize).val(Math.round(size * 100) / 100);

            e.removeClass('dnTicketdesigner-object-isDragged');
            e.css('position', '');
            e.css('font-size', fontSize + 'px');

            disableExampleButton();
        }

        $(document).on('change', '.dnTicketdesigner-field', function () {
            var field = $(this);
            var type = field.attr('data-type');
            var data = 'data-position-' + type;
            var id = $(this).attr('id');
            var val = $(this).val();


            $('.dnTicketdesigner-object').each(function () {
                if ($(this).attr(data).substring(1) == id) {
                    var object = $(this);
                    var minValue = null;
                    var maxValue = null;
                    getVariables(object);

                    if (type == 'size') {
                        minValue = minFieldSize;
                        maxValue = maxFieldSize;
                    } else if (type == 'x') {
                        minValue = 0.04;
                        maxValue = 16.8;
                    } else if (type == 'y') {
                        minValue = 0.86;
                        maxValue = 29.65;
                    } else if (type == 'show') {
                        if (field.prop('checked') == true) {
                            object.appendTo('.dnTicketdesigner-container-show');
                        } else {
                            object.appendTo('.dnTicketdesigner-container-list');
                        }
                    }

                    if (maxValue != null) {
                        if (minValue > val) {
                            field.val(minValue);
                        } else if (maxValue < val) {
                            field.val(maxValue);
                        }
                    }

                    initialize(object);
                    return false;
                }
            });

            disableExampleButton();
        });

        $('.dnTicketdesigner-field').keydown(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                $(this).blur();
                return false;
            }
        });

        $(window).resize(function () {
            ticketdesignerInitialize();
        });

        ticketdesignerInitialize();

        $(document).on('admin_menu.show.done', function (e) {
            ticketdesignerInitialize();
        });

        $(document).on('admin_menu.hide.done', function (e) {
            ticketdesignerInitialize();
        });

        function disableExampleButton() {
            $('#ticket-design-preview').addClass('d-none');
            $('#ticket-design-preview-notice').removeClass('d-none');
        }

        $(document).on('click', '.exampleButtonDisabled', function (e) {
            e.preventDefault();
        });
    }
});